import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {HeaderContainerComponent} from "../header-container/header-container.component";
import {PageContainerComponent} from "../page-container/page-container.component";
import {PageScrollableComponent} from "../page-scrollable/page-scrollable.component";
import {ApplyHeightDirective} from "../../_directives/apply-height.directive";
import {NgTemplateOutlet} from "@angular/common";

@Component({
  selector: 'app-edit-component-base',
  imports: [
    HeaderContainerComponent,
    PageContainerComponent,
    PageScrollableComponent,
    ApplyHeightDirective,
    NgTemplateOutlet
  ],
  templateUrl: './edit-component-base.component.html',
  styleUrl: './edit-component-base.component.scss'
})
export class EditComponentBaseComponent {
  @Input() id: string | undefined;
  @Input() title: string = "";
  @Input() view: number | undefined;
  @Output() onSave: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();

  @Output() onNextView = new EventEmitter<number>();
  @Output() onPreviousView = new EventEmitter<number>();

  @Input() templates: { [key: string]: TemplateRef<any> } = {};
}
